import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { isExternalUser } from "@/helpers/store";
import HomePage from "../views/HomePage.vue";
import OverviewPage from "../views/OverviewPage.vue";
import LivePage from "../views/LivePage.vue";
import IncidentsPage from "../views/IncidentsPage.vue";
import EventsPage from "../views/EventsPage.vue";
import BurstsPage from "../views/BurstsPage.vue";
import TasksPage from "../views/TasksPage.vue";
import SettingsPage from "../views/SettingsPage.vue";
import GraphsPage from "../views/GraphsPage.vue";
import PlotsPage from "../views/PlotsPage.vue";
import AggregatorsPage from "../views/AggregatorsPage.vue";
import AnimationPage from "../views/AnimationPage.vue";
import LoginPage from "../views/LoginPage.vue";
import AlarmsPage from "../views/AlarmsPage.vue";
import DamagedbPage from "../views/DamagedbPage.vue";
import CommissioningPage from "../views/CommissioningPage.vue";
import ExternalPage from "../views/ExternalPage.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: HomePage,
  },
  {
    path: "/overview",
    name: "Overview",
    component: OverviewPage,
  },
  {
    path: "/live",
    name: "Live",
    component: LivePage,
  },
  {
    path: "/aggregators",
    name: "Aggregators",
    component: AggregatorsPage,
  },
  {
    path: "/graphs",
    name: "Graphs",
    component: GraphsPage,
  },
  {
    path: "/incidents",
    name: "Incidents",
    component: IncidentsPage,
  },
  {
    path: "/events",
    name: "Events",
    component: EventsPage,
  },
  {
    path: "/bursts",
    name: "Bursts",
    component: BurstsPage,
    props: (route) => route.query,
  },
  {
    path: "/tasks",
    name: "Tasks",
    component: TasksPage,
  },
  {
    path: "/plots",
    name: "Plots",
    component: PlotsPage,
  },
  {
    path: "/settings",
    name: "Settings",
    component: SettingsPage,
  },
  {
    path: "/animation",
    name: "Animation",
    component: AnimationPage,
  },
  {
    path: "/login",
    name: "Login",
    component: LoginPage,
  },
  {
    path: "/alarms",
    name: "Alarms",
    component: AlarmsPage,
  },
  {
    path: "/damagedb",
    name: "DamageDB",
    component: DamagedbPage,
  },
  {
    path: "/commissioning",
    name: "Commissioning",
    component: CommissioningPage,
  },
  {
    path: "/external",
    name: "External",
    component: ExternalPage,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Routes reachable by an external_user. Everything else redirects to /external.
// /settings stays reachable so the cog still has something to point at (full
// settings lockdown for external_user is a follow-up).
const EXTERNAL_USER_ROUTES = new Set(["/external", "/settings", "/login"]);

router.beforeEach((to) => {
  if (isExternalUser() && !EXTERNAL_USER_ROUTES.has(to.path)) {
    return { path: "/external" };
  }
});

export { router };
